<template>
  <q-btn
    v-if="text || appendText"
    :icon="icon"
    :color="color"
    :size="size"
    dense
    flat
  >
    <q-tooltip>
      {{ tooltip }}
    </q-tooltip>
    <q-popup-proxy>
      <q-banner
        :dark="isDarkModeGlobal"
        :class="isDarkModeGlobal ? 'bg-black' : ''"
      >
        <template #avatar>
          <q-icon
            :name="icon"
            :color="color"
          />
        </template>
        <div v-if="text" v-html="text" />
        <a
          v-if="link"
          :href="link"
          target="_blank"
        >{{ linkText }}</a>
        <div v-if="appendText" v-html="appendText" />
      </q-banner>
    </q-popup-proxy>
  </q-btn>
  <q-btn
    v-else
    :icon="icon"
    :color="color"
    :size="size"
    dense
    flat
    @click="openInNewTab"
  >
    <q-tooltip>
      {{ tooltip }}
    </q-tooltip>
  </q-btn>
</template>

<script setup lang="ts">
import {storeToRefs} from "pinia"
import { useCalculatorStore } from '../stores/calculator.store'
const calculatorStore = useCalculatorStore()
const {
  isDarkModeGlobal
} = storeToRefs(calculatorStore)
const props = defineProps({
  icon: {
    type: String,
    default: 'book'
  },
  size: {
    type: String,
    default: 'sm'
  },
  tooltip: {
    type: String,
    default: 'Click to show reference'
  },
  color: {
    type: String,
    default: 'primary'
  },
  text: {
    type: String,
    default: ''
  },
  appendText: {
    type: String,
    default: ''
  },
  link: {
    type: String,
    default: ''
  },
  linkText: {
    type: String,
    default: 'reference'
  },
})

function openInNewTab() {
  window.open(props.link, '_blank', 'noreferrer')
}
</script>